export default __webpack_public_path__ + "static/media/hero1.27e63902.jpg";